import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { Page } from "src/app/model/Page";
import { WalkinAppointmentListModel } from "src/app/model/WalkinAppointmentListModel";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: "app-secure-help-file",
  templateUrl: "./help-file.component.html",
  styleUrls: ["./help-file.component.scss"],
})
export class helpfileComponent implements OnInit {
  list: Page<WalkinAppointmentListModel>;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<WalkinAppointmentListModel> = new MatTableDataSource();
 
  
  ngOnInit(): void {
    //this.loadData();
    
  }
  

 
}